export const environment = {
  strapiUrl: "https://enwyse-strapi.azurewebsites.net/api/",
  enwyseApiUrl: "https://enwyse-mobile-api.azurewebsites.net/api/",
  defaultLanguage: "nl",
};
